import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import IconRail from '@ui/rail/IconRail';
import DomainSelectorFragment from '@app/site/secured/_common/layout/fragment/DomainSelectorFragment';
import UserMenuItemFragment from '@app/site/secured/_common/layout/fragment/UserMenuItemFragment';
import FooterFragment from '@app/site/secured/_common/layout/fragment/FooterFragment';
import { useBiHotelForApp } from './BiScopeHooks';
import { BiFullWidthProvider } from './BiFullWidth';
import { BiReport, biRailGroups, REPORTS } from './BiReports';

// The BI domain (BI_TOOL, Direction D): the RoomPulse top bar of the BI layout, the icon rail of the reports on the
// left (a row of icons below the sm width), and the report on the right. The rail keeps the address query, so a
// change of report keeps the hotel and the period (grill decision 14).

// /secured/bi opens the Segmentation report (the Dashboard is not ready) and keeps the address query of a shared link.
export const BiIndexRedirect = () => {
	const { search } = useLocation();
	return <Navigate to={`segmentation${search}`} replace />;
};

const BiLayout = () => {
	const navigate = useNavigate();
	useBiHotelForApp();
	const { pathname, search } = useLocation();
	const item = (report: BiReport) => ({
		...report,
		active: pathname.endsWith(`/${report.id}`),
		onSelect: () => navigate(`/secured/bi/${report.id}${search}`),
	});

	return <div className="flex min-h-full flex-col bg-gray-100">
		<nav className="border-b border-gray-200 bg-white">
			<div className="flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
				<div className="flex items-center gap-3">
					<DomainSelectorFragment />
					<img className="hidden h-6 w-auto sm:block" src="/assets/img/brand/rp-logo.svg" alt="RoomPulse" />
				</div>
				<UserMenuItemFragment />
			</div>
		</nav>
		<div className="flex flex-1 flex-col sm:flex-row">
			<IconRail label="BI reports" groups={biRailGroups(REPORTS.map(item))} />
			<div className="min-w-0 flex-1">
				<BiFullWidthProvider><Outlet /></BiFullWidthProvider>
			</div>
		</div>
		<FooterFragment />
	</div>;
};

export default BiLayout;
